// extracted by mini-css-extract-plugin
export default {"container":"not_found_message_container__45iyd","notFound":"not_found_message_notFound__GYBOA"};